import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

class Button extends Component {
  state = {};
  render() {
    return this.props.to ? (
      <ButtonLink {...this.props}>{this.props.children}</ButtonLink>
    ) : (
      this.props.type==='submit' ?
      <ButtonSubmit {...this.props}>{this.props.children}</ButtonSubmit> :
      <Root {...this.props}>{this.props.children}</Root>
    );
  }
}

const buttonCSS = css`
  display: inline-block;
  padding: 7px;
  padding: 15px 50px 13px;
  background: ${({ theme }) => theme.colorPrimary};
  border: 1px solid ${({ theme }) => theme.colorPrimary};
  color: #fff;
  font-family: ${({ theme }) => theme.fontMedium};
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.33s;
  &:hover {
    background: #fff;
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

const ButtonLink = styled(Link)`
  ${buttonCSS};
`;

const Root = styled.a`
  ${buttonCSS};
`;

const ButtonSubmit = styled.button`
  ${buttonCSS};
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js